





















import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import Hls from 'hls.js'
import moment from 'moment'
import { getPlatform, getChannel } from '@/utils'
import { v1 } from 'uuid';
import Store from 'store'

import Video from './Video.vue'
import { loadHlsVideo } from 'utils/index'
import { reportViewDurationPost, reportViewDurationPostReplay } from '@/api/ZnPlayer'
@Component({
  components: {
    Video
  },
})
export default class VideoContainer extends Vue {
  @Prop() private videoSource!: any
  @Prop() private isLiveStream!: boolean
  @Prop() private liveMessageShow!: boolean
  @Prop() private liveMessageTitle!: string
  @Prop() private roomId!: string
  @Prop() private userId!: string
  @Prop() private liveMessageContent!: string
  @Prop() private roomPic!: string
  @Prop({
    type: Boolean,
    default: false
  }) private showControls!: boolean;
  @Prop({
    type: Boolean,
    default: false
  }) private isVideoContain!: boolean;
  private sessionId = v1().slice(0, 32)
  private startTime?: number
  private pauseTime = 0
  private pauseStartTime = 0
  private timer?: NodeJS.Timeout

  private specialFlag = false
  private created () {
    const { businessType } = this.$route.query
    this.specialFlag = businessType === '5'
  }
  private reportViewDuration () {
    const timeGap = Store.get('timeGap')
    const dataSource = this.$route.query.dataSource as string
    const sid = this.$store.state.sid || this.$route.query.sid
    const userId = this.$store.state.userInfo.userId || this.$route.query.userId
    if (!this.startTime) {
      this.startTime = Date.now() - timeGap
    }
    const endTime = Date.now() - timeGap
    const duration = endTime - this.startTime - (this.isLiveStream ? 0 : this.pauseTime)

    const reportParams = {
      dataSource,
      canalType: 1,
      umId: userId,
      sid,
      roomId: this.roomId,
      startTime: moment(this.startTime).format('YYYY-MM-DD HH:mm:ss'),
      endTime: moment(endTime).format('YYYY-MM-DD HH:mm:ss'),
      id: `${this.roomId}${this.startTime}`,
      duration: duration < 1000 ? 1000 : duration,
      sessionId: this.sessionId,
      source: getPlatform(),
      channel: getChannel(),
      dataType: '1',
    } as any
    if (!this.isLiveStream) {
      reportViewDurationPostReplay({ ...reportParams, os: getPlatform(false, true) })
    } else {
      // reportParams.phoneNum = this.phoneNum
      // reportParams.referralCode = this.referralCode
      // reportParams.empName = this.userName
      reportViewDurationPost(reportParams)
    }
  }

  private startReportViewDuration () {
    if (this.pauseStartTime) {
      this.pauseTime = Date.now() - this.pauseStartTime + this.pauseTime
      this.pauseStartTime = 0
    }
    this.reportViewDuration()
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
        this.startReportViewDuration()
    }, this.$store.state.reportInterval * 1000)
  }

  private stopReport () {
    if (this.timer) {
      if (!this.isLiveStream) {
        this.pauseStartTime = Date.now()
      }
      this.reportViewDuration();
      clearTimeout(this.timer);
    }
  }

  private beforeDestroy () {
    this.stopReport()
  }
}
